import { createAction } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { Tariff } from '@personal-area/global/accounts/models';

export const GET_TARIFFS = '[Dictionary] Get tariffs';
export const GET_TARIFFS_SUCCESS = '[Dictionary] Get tariffs success';
export const GET_TARIFFS_FAIL = '[Dictionary] Get tariffs fail';
export const SET_TARIFFS_LOADING = '[Dictionary] Set tariffs loading';

export const GetTariffs = createAction(GET_TARIFFS, (userId: number) => ({ userId }));
export const GetTariffsSuccess = createAction(GET_TARIFFS_SUCCESS, (tariffs: Tariff[]) => ({ tariffs }));
export const GetTariffsFail = createAction(GET_TARIFFS_FAIL, (err: HttpErrorResponse) => ({ err }));
export const SetTariffsLoading = createAction(SET_TARIFFS_LOADING);
